import { SvgScissors } from '@loomhq/lens';
import React from 'react';
import { connect } from 'react-redux';

import * as device from 'utilities/device';

import CollapsibleSideButton from '../collapsible-side-button';

class TrimModeButton extends React.Component {
  static defaultProps = {
    onClick: () => {},
  };

  render() {
    const {
      collaboratePermissions,
      currentUserIsOwner,
      enterTrimEnabled,
      isCollapsed,
      onClick,
      disabled,
      videoIsTeamShared,
    } = this.props;

    return (
      !device.isMobile &&
      (currentUserIsOwner ||
        videoIsTeamShared ||
        collaboratePermissions.write) && (
        <CollapsibleSideButton
          icon={<SvgScissors />}
          isCollapsed={isCollapsed}
          isDisabled={disabled || !enterTrimEnabled}
          onClick={enterTrimEnabled ? onClick : undefined}
        >
          Trim video
        </CollapsibleSideButton>
      )
    );
  }
}

const mapStateToProps = state => {
  const {
    player_ready,
    video,
    current_user_is_owner,
    video_is_team_shared: videoIsTeamShared,
  } = state.share_video;

  const { processing_information = {} } = video;
  const { trim_id, trim_progress } = processing_information;

  // the user should be able to enter trim mode if the player is ready or if
  // a trim job is progressing
  const enterTrimEnabled =
    player_ready || (trim_id != null && trim_progress !== 100);

  return {
    collaboratePermissions: video.collaboratePermissions,
    currentUserIsOwner: current_user_is_owner,
    enterTrimEnabled,
    videoIsTeamShared,
  };
};

export default connect(mapStateToProps)(TrimModeButton);
